const galleries = document.querySelectorAll('.pgal');

const vendors = document.querySelectorAll('.ve');
const popups = document.querySelectorAll('.pe');

const select = document.querySelector('#select-category');

const popupBox = document.querySelector('.vendor-popup');
let curpopup = undefined;

function galleryClick(e) {
    const gal = e.target.parentElement;
    const galLen = gal.querySelectorAll('img').length - 1;
    const btn = e.target;

    const imgs = gal.querySelectorAll('img');
    let curimg = gal.querySelectorAll('.active')[0];

    if (btn.className === 'next-btn') {
        const nextimg = (curimg.nextElementSibling === null || curimg.nextElementSibling.tagName !== 'IMG') ? gal.getElementsByTagName('img')[0] : curimg.nextElementSibling;
        curimg.classList.remove('active');
        nextimg.classList.add('active');
        curimg = nextimg;
    } else if (btn.className === 'prev-btn') {
        const previmg = (curimg.previousElementSibling === null || curimg.previousElementSibling.tagName !== 'IMG') ? gal.getElementsByTagName('img')[galLen] : curimg.previousElementSibling;
        curimg.classList.remove('active');
        previmg.classList.add('active');
        curimg = previmg;
    }

    const galImgCount = gal.parentElement.querySelector('.gimgcnt').querySelectorAll('span');
    let curcount = galImgCount[0];
    let totalcount = galImgCount[1];

    for (let i = 0; i < imgs.length; i++) {
        if (imgs[i] === curimg) curcount.textContent = i + 1;
    }
}

for (let gal of galleries) {
    gal.addEventListener('click', galleryClick);
    if (gal.querySelectorAll('active').length === 0) gal.querySelectorAll('img')[0].classList.add('active');

    const galLen = gal.querySelectorAll('img').length;
    const galImgCount = gal.querySelector('.gimgcnt').querySelectorAll('span');
    galImgCount[0].textContent = 1;
    galImgCount[1].textContent = " / "+galLen;
}

function vendorClick(e) {
    if (popupBox.classList.contains('open') || e.target.tagName === 'A') return false;
    let popup = popups[Array.from(vendors).indexOf(this)];
    curpopup = popup;

    popupBox.classList.add('open');
    popup.classList.add('active');
}

for (let entry of vendors) {
    entry.addEventListener('click', vendorClick);
}

function popupBoxClick(e) {
    if (e.target.className !== 'vendor-popup open' && e.target.className !== 'close-btn') return false;

    curpopup.querySelector('.bio').scrollTop = 0;

    let gal = curpopup.querySelector('.pgal');

    gal.querySelector('.active').classList.remove('active');
    gal.querySelectorAll('img')[0].classList.add('active');

    const galLen = gal.querySelectorAll('img').length;
    const galImgCount = gal.querySelector('.gimgcnt').querySelectorAll('span');
    galImgCount[0].textContent = 1;
    galImgCount[1].textContent = " / "+galLen;

    curpopup.classList.remove('active');
    popupBox.classList.remove('open');
}

popupBox.addEventListener('click', popupBoxClick);

function selectChange() {
  document.querySelector('.no-category').classList.remove('show');
  if (vendors.length === 0) {
    document.querySelector('.no-category').classList.add('show');
    return false;
  }
  if (select.value === "none") {
    for (let el of vendors) {
      el.classList.remove('hidden');
    }
  } else {
    for (let el of vendors) {
      el.classList.remove('hidden');
      if (el.dataset.categories.split(',').includes(select.value)) continue;
      el.classList.add('hidden');
    }
    let truth = [...document.querySelectorAll('.ve')].every(function(e) {
      return e.classList.contains('hidden');
    });
    if (truth) document.querySelector('.no-category').classList.add('show');
  }
}
  
select.addEventListener('change', selectChange);